import bind from 'bind-decorator';
import { observable } from 'mobx';
import { notification } from 'antd';
import { Integration } from 'models/Integration';
import { getIntegrations, updateAccountIntegrations } from 'services/Admin';
import { getAccount } from 'services/Accounts';
import { AccountsStore } from 'stores/Accounts';

export class AdminAccountIntegrationsModel {
  @observable loading: boolean = false;
  @observable saving: boolean = false;
  @observable loaded: boolean = false;
  @observable available: Integration[] = [];
  @observable selected: Integration[] = [];

  accountId: string = '';

  constructor(accountId: string) {
    this.accountId = accountId;
  }

  @bind
  async refresh() {
    this.loading = true;

    try {
      const [integrationsResponse, accountResponse] = await Promise.all([
        getIntegrations(),
        getAccount(this.accountId)
      ]);

      this.available = integrationsResponse.data.data || [];
      this.selected = accountResponse.data.data.integrations || [];
      this.loaded = true;
    } catch (e) {
    }

    this.loading = false;
  }

  @bind
  setSelected(ids: string[]) {
    this.selected = ids.map(id => {
      const existing = this.selected.find(s => s.integrationId === id);
      if (existing) return existing;
      const fromAvailable = this.available.find(a => a.integrationId === id);
      return fromAvailable || { integrationId: id, name: id };
    });
  }

  @bind
  async save() {
    this.saving = true;

    try {
      const response = await updateAccountIntegrations(this.accountId, this.selected);

      const account = AccountsStore.getAccount(this.accountId);
      if (account) {
        account.integrations = response.data.data.integrations || [];
      }
      this.selected = response.data.data.integrations || [];

      notification.success({
        message: 'Integrations saved',
        description: `Linked ${this.selected.length} integration(s) to this account`
      });
    } catch (e) {
    }

    this.saving = false;
  }
}
